import {isEmptyValue} from '@netx/core-components/Form/utils';
import {AttributeValue} from '../types';

/**
 * Normalize attribute value to array\
 * In a lot of cases saving attribute values to the server, it wants an array
 * regardless of the multi-value ability of an attribute template type\
 */
export const normalizeValue = (value: AttributeValue) => {
	if (isEmptyValue(value)) return [];
	if (!Array.isArray(value)) return [value];
	return value;
};

export default normalizeValue;
